import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ApiUrlService } from '@pryspace/shared/environments';
import { HandoffExchangeResponse } from './models';
import { TokenStore } from './token-store.service';

@Injectable({ providedIn: 'root' })
export class HandoffService {
  private http = inject(HttpClient);
  private api = inject(ApiUrlService);
  private tokens = inject(TokenStore);

  /** Create the backend-owned redirect from PrySpace into PryOps. */
  async createPryOpsRedirect(next = '/app/dashboard'): Promise<string> {
    const targetRedirectUri = this.api.handoffRedirectUri('pryops');
    if (!targetRedirectUri) throw new Error('sso_target_not_configured');
    const response = await firstValueFrom(this.http.post<{ redirectUrl: string }>(
      this.api.url('v1/shared/handoff/'),
      {
        sourceApp: 'pryspace',
        targetApp: 'pryops',
        targetRedirectUri,
        next,
      },
    ));
    return response.redirectUrl;
  }

  /** Exchange a single-use PryOps handoff code for a customer session. */
  async exchangeHandoff(code: string): Promise<HandoffExchangeResponse> {
    const targetRedirectUri = this.api.handoffRedirectUri('pryspace');
    if (!targetRedirectUri) throw new Error('sso_target_not_configured');
    const response = await firstValueFrom(this.http.post<HandoffExchangeResponse>(
      this.api.url('v1/shared/handoff/exchange/'),
      {
        code,
        targetApp: 'pryspace',
        targetRedirectUri,
      },
    ));
    this.tokens.setCustomerTokens(response.accessToken, response.refreshToken);
    return response;
  }
}
